import { render, staticRenderFns } from "./ActivateSentPage.vue?vue&type=template&id=c0c0420c&scoped=true"
import script from "./ActivateSentPage.vue?vue&type=script&lang=ts"
export * from "./ActivateSentPage.vue?vue&type=script&lang=ts"
import style0 from "./ActivateSentPage.vue?vue&type=style&index=0&id=c0c0420c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c0420c",
  null
  
)

export default component.exports